import {alertsManager} from "../App";

export function showMessage(title, message) {
    alertsManager.add({
        header: title,
        messages: [{text: message}],
        type: 'success',
        autoDismiss: true,
        onClose: () => null,
    });
}

export function showErrorMessage(title, message) {
    const alertKey = title.toString().replace(' ', '_').toLowerCase() + '_error_' + Date.now().toString();
    const timeoutSeconds = 10;
    alertsManager.add({
        key: alertKey,
        header: title,
        messages: [{text: message}],
        type: 'error',
        autoDismiss: false,
        onClose: () => null,
    });
    // Dismiss the error after 10 seconds
    setTimeout(function () {
        alertsManager.remove(alertKey);
    }, timeoutSeconds * 1000);
}